<template>
  <div class="congrans-text" :style="{'background': bg}">
   <p class="congrans-text__span" :style="{'color': color}">{{ text  }}</p>
  </div>
</template>

<script>
  export default {
    props: {
      text: {
        type: String,
        default: ''
      },
      color: {
        type: String,
        default: ''
      },
      bg: {
        type: String,
        default: ''
      },

    },
  }
</script>

<style lang="scss" scoped>
.congrans-text {
  width: 100%;
  font-family: $ff-3;
  font-size: 12px;
  text-decoration: none;
  text-align: center;
  overflow: hidden;
  &__span {
    animation: moveRightLeft 9s alternate infinite linear;
    white-space: nowrap;
    @include desde($medium) {
      animation: moveRightLeft 11s alternate infinite linear;
    }
    @include desde($large) {
      animation: moveRightLeft 25s alternate infinite linear;
    }
  }
}

@keyframes moveRightLeft {
  0% {
    transform: translateX(0); /* Posición inicial (izquierda) */
  }
  25% {
    transform: translateX(25%);
  }
  50% {
    transform: translateX(50%);
  }
  75% {
    transform: translateX(100%); /* Posición final (derecha) */
  }
  100% {
    transform: translateX(-100%);
  }
}
</style>